import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { supabase } from "../../supabaseClient";
import rewardsIcon from "../../Assets/Icons/badge.png";
import firstMedalIcon from "../../Assets/Icons/first-medal.png";
import secondMedalIcon from "../../Assets/Icons/second-medal.png";
import thirdMedalIcon from "../../Assets/Icons/third-medal.png";
import LoaderBox from "../HomePage/LoaderBox";
import Navigation from "../Navigation/Navigation";
import HomeFooter from "../HomePage/HomeFooter";

// POMOĆNA KOMPONENTA ZA ANIMACIJU BROJEVA
const Counter = ({ target, duration = 1500 }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!target) return;
    let start = 0;
    // Čistimo string od točaka i simbola da dobijemo čisti broj
    const end = parseInt(target.toString().replace(/\D/g, ""));
    if (isNaN(end) || start === end) {
      setCount(end || 0);
      return;
    }

    let totalMiliseconds = duration;
    let incrementTime = 11;
    let timer = setInterval(() => {
      start += Math.ceil(end / (totalMiliseconds / incrementTime));
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(start);
      }
    }, incrementTime);

    return () => clearInterval(timer);
  }, [target, duration]);

  return <span>{count.toLocaleString("de-DE")}€</span>;
};

const Rewards = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    fetchRewards();
  }, []);

  const fetchRewards = async () => {
    try {
      const { data: settings, error } = await supabase
        .from("site_settings")
        .select("*")
        .single();

      if (error) throw error;
      setData(settings);
    } catch (error) {
      console.error("Greška pri dohvaćanju nagrada:", error.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading || !data)
    return <LoaderBox text="Učitavanje nagradnog fonda..." />;

  // Mapiranje podataka iz baze u format za grid
  const rewardsGrid = [
    {
      place: "1. MJESTO",
      prize: data.first_place,
      sub: "+ Pehar",
      img: firstMedalIcon,
    },
    {
      place: "2. MJESTO",
      prize: data.second_place,
      sub: "+ Pehar",
      img: secondMedalIcon,
    },
    {
      place: "3. MJESTO",
      prize: data.third_place,
      sub: "+ Pehar",
      img: thirdMedalIcon,
    },
  ];

  const extraPrizes = [
    { title: "Najbolji igrač", gift: data.best_player },
    { title: "Najbolji strijelac", gift: data.best_scorer },
    { title: "Najbolji golman", gift: data.best_gk },
  ];

  const gridVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.5 },
    },
  };

  return (
    <>
      <Navigation />
      <div className="rewards-wrapper">
        <div className="rewards-header">
          <h3>Nagradni Fond</h3>
          <img src={rewardsIcon} alt="Rewards" className="header-img" />
        </div>

        <div className="total-fund-container">
          <span className="label">UKUPNI FOND</span>
          <h2 className="fund-amount">
            <Counter target={data.total_fund} />
          </h2>
        </div>

        <motion.div
          className="rewards-grid"
          variants={gridVariants}
          initial="hidden"
          animate="visible"
        >
          {rewardsGrid.map((item, index) => (
            <motion.div
              key={index}
              className={`reward-card rank-${index + 1}`}
              variants={cardVariants}
            >
              <div className="rank-img-container">
                <img
                  src={item.img}
                  alt={item.place}
                  className="rank-medal-img"
                />
              </div>
              <div className="reward-info">
                <h4>{item.place}</h4>
                <span className="amount">
                  <Counter target={item.prize} duration={1500} />
                </span>
                <p className="description">{item.sub}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          className="extra-rewards-section"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8, duration: 0.5 }}
        >
          <h3>Dodatne Nagrade</h3>
          <div className="extra-grid">
            {extraPrizes.map((extra, i) => (
              <motion.div
                key={i}
                className="extra-card"
                variants={cardVariants}
              >
                <span className="extra-title">{extra.title}</span>
                <span className="extra-gift">{extra.gift}</span>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
      <HomeFooter />
    </>
  );
};

export default Rewards;
